import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

function ProtectedRoute({ children }) {
  const { isAdmin } = useAuth();

  if (!isAdmin) {
    // 로그인 안 됐으면 로그인 페이지로
    return <Navigate to="/login" replace />;
  }

  return children;
}

export default ProtectedRoute;
